import * as Animate from "react-reveal";

const benefits = [
  {
    number: "01",
    title: "One payroll relationship",
    desc:
      "Bring employees and contractors into one coordinated process with fewer handoffs between teams.",
  },
  {
    number: "02",
    title: "Clearer country support",
    desc:
      "Understand what each market needs with practical guidance from a team that knows global work.",
  },
  {
    number: "03",
    title: "A more confident payday",
    desc:
      "Give finance teams control while every worker gets a clearer view of their payout.",
  },
  {
    number: "04",
    title: "People when you need them",
    desc:
      "Move from setup to payroll review with a real Utiva specialist beside your team.",
  },
];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayBenefitsSection = () => {
  return (
    <section className="bg-white py-16 lg:py-[105px] px-6 lg:px-8">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="max-w-[920px] mb-10 lg:mb-[47px]">
            <p className="flex items-center gap-3 text-primary text-[15px] font-black tracking-[0.11em] uppercase mb-4">
              <span className="w-10 h-[3px] bg-secondary inline-block shrink-0"></span>
              Why Teams Choose Utiva Pay
            </p>
            <h2
              className="text-primary tracking-[-0.052em] leading-[1.04] font-black mb-5"
              style={{ fontSize: "clamp(40px, 4.5vw, 65px)" }}
            >
              Less operational noise.{" "}
              <mark style={markStyle}>More confidence around payday.</mark>
            </h2>
            <span className="text-[#5c6274] text-[18px] leading-[1.7] max-w-[780px] block">
              A practical payroll experience built around how distributed teams
              actually work.
            </span>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-b border-[#dce3f1]">
          {benefits.map((benefit, index) => {
            const isLast = index === benefits.length - 1;
            return (
              <Animate.Fade bottom key={benefit.number}>
                <article
                  className={`border-l border-r border-b lg:border-b-0 border-[#dce3f1] relative p-7 min-h-[250px] lg:min-h-[330px] ${
                    isLast ? "" : "lg:border-r-0"
                  }`}
                  style={{ background: isLast ? "#fff8e8" : "transparent" }}
                >
                  <span className="text-[#986500] text-[16px] font-black">
                    {benefit.number}
                  </span>
                  <h3 className="text-primary font-bold text-[25px] leading-[1.25] mt-[45px] lg:mt-[70px] mb-[14px]">
                    {benefit.title}
                  </h3>
                  <p className="text-[#5c6274] text-[16px] leading-[1.7] m-0">
                    {benefit.desc}
                  </p>
                  <b
                    className="text-primary font-normal absolute"
                    style={{ fontSize: "21px", bottom: "22px", right: "23px" }}
                  >
                    ↗
                  </b>
                </article>
              </Animate.Fade>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PayBenefitsSection;
